import { HelmetProvider } from "react-helmet-async";
import Layout from "./UI/Layout";
import { Outlet } from "react-router-dom";

const App = () => {
  const helmetContext = {};

  return (
    <HelmetProvider context={helmetContext}>
      <Layout>
        <Outlet />
      </Layout>
    </HelmetProvider>
  );
};

export default App;
